import React, { useState } from "react";
import styled from "styled-components";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const ContactSection = styled.section`
  background: #fff;
  position: relative;
  padding: 50px 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 70vh;
    background: rgba(255, 255, 255, 0.5);
  }
`;

const Container = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 90%;
  max-width: 800px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    display: grid;
    justify-content: center;
    align-items: center;
  }
`;

const CardHeight = "350px";

const ContactInfo = styled.div`
  background: rgba(234, 56, 76, 0.95);
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
`;
const InfoTitle = styled.h3`
  font-size: 1.5rem;
  margin-bottom: 1.5rem;
  color: #fff;
`;
const InfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
  color: #fff;
  
  svg {
    margin-right: 1rem;
    font-size: 1.25rem;
  }
`;

const FormContainer = styled.div`
  background: #fff5f5;
  padding: 40px;
  border-radius: 10px;
  height: ${CardHeight};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const SectionTitle = styled.h2`
  font-size: 20px;
  text-align: center;
  margin-bottom: 10px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
  flex: 1;
`;

const InputField = styled.input`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
`;

const TextArea = styled.textarea`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 14px;
  width: 100%;
  height: 80px;
  resize: none;
`;

const SubmitButton = styled.button`
  background: #e2384c;
  color: white;
  border: none;
  padding: 10px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: background 0.3s ease;
  &:hover {
    background: #c12d3e;
  }
  &:disabled {
    background: gray;
    cursor: not-allowed;
  }
`;

const FormStatus = styled.p`
  font-size: 14px;
  text-align: center;
  color: green;
`;

const Contact = () => {
  const [formData, setFormData] = useState({ name: "", email: "", message: "" });
  const [formStatus, setFormStatus] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setTimeout(() => {
      setFormStatus("Message sent successfully!");
      setIsSubmitting(false);
      setFormData({ name: "", email: "", message: "" });
    }, 1500);
  };

  return (
    <ContactSection style={{background:'#fff'}} id="contact">
      <Container>
      <ContactInfo>
          <InfoTitle>Get in Touch</InfoTitle>
          <InfoItem>
            <FaPhone /> +263 77 581 6439
          </InfoItem>
          <InfoItem>
            <FaEnvelope /> richmantembo04@gmail.com
          </InfoItem>
          <InfoItem>
            <FaMapMarkerAlt /> 123 Faith Street, Bulawayo, Zimbabwe
          </InfoItem>
        </ContactInfo>
        <FormContainer>
          <SectionTitle style={{color:'#c12d3e'}}>Contact Us</SectionTitle>
          <Form onSubmit={handleSubmit}>
            <InputField type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
            <InputField type="email" name="email" placeholder="Your Email" value={formData.email} onChange={handleChange} required />
            <TextArea name="message" placeholder="Your Message" value={formData.message} onChange={handleChange} required />
            <SubmitButton type="submit" disabled={isSubmitting}>{isSubmitting ? "Sending..." : "Send Message"}</SubmitButton>
          </Form>
          {formStatus && <FormStatus>{formStatus}</FormStatus>}
        </FormContainer>
      </Container>
    </ContactSection>
  );
};

export default Contact;
